import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Main from './components/Main'
import Overlay from './components/Overlay'
import Snake from './components/Snake'

const App = () => (
  <Switch>
    <Route exact path='/' component={Main}/>
    <Route path='/overlay/:key' component={Overlay}/>
    <Route path='/snake' component={Snake}/>
  </Switch>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js